import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const unionAsync = (first, second, comparer) => {
    const generator = async () => {
        const result = [];
        const values = await Promise.all([first.toArray(), second.toArray()]);
        for (const source of values) {
            for (const value of source) {
                let exists = false;
                for (const resultValue of result) {
                    if (await comparer(value, resultValue) === true) {
                        exists = true;
                        break;
                    }
                }
                if (exists === false) {
                    result.push(value);
                }
            }
        }
        return result;
    };
    return new BasicParallelEnumerable({
        generator,
        type: 0,
    });
};
